import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { AlertModule } from 'ngx-bootstrap/alert';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';

// Modules
import { PipesModule } from '../pipes/pipes.module';
import { ProtocolDroidModule } from '../services/protocol-droid/protocol-droid.module';
import { SvgIconModule } from './components/svg-icon/svg-icon.module';

// Components
import { AlertWarningComponent } from './components/alert/alert.component';
import { ApiActionFormComponent } from './components/async-action-form/api-action-form/api-action-form.component';
import { EmailActionFormComponent } from './components/async-action-form/email-action-form/email-action-form.component';
import { WorkflowActionFormComponent } from './components/async-action-form/workflow-action-form/workflow-action-form.component';
import { AvatarComponent } from './components/avatar/avatar.component';
import { BadgeErrorsComponent } from './components/badge-errors/badge-errors.component';
import { BadgeInfosComponent } from './components/badge-infos/badge-infos.component';
import { BadgeComponent } from './components/badge/badge.component';
import { BotChannelIconeComponent } from './components/bot-channel-icone/bot-channel-icone.component';
import { BoxDashComponent } from './components/box-dash/box-dash.component';
import { ButtonCopyComponent } from './components/button-copy/button-copy.component';
import { ButtonFlashingComponent } from './components/button-flashing/button-flashing.component';
import { ButtonIconComponent } from './components/button-icon/button-icon.component';
import { ButtonRoundComponent } from './components/button-round/button-round.component';
import { CaretComponent } from './components/caret/caret.component';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { EphemeralMessageComponent } from './components/ephemeral-message/ephemeral-message.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { InputTextComponent } from './components/input-text/input-text.component';
import { MultipleSelectionDropdownComponent } from './components/multiple-selection-dropdown/multiple-selection-dropdown.component';
import { NavPanelsComponent } from './components/nav-panels/nav-panels.component';
import { NavTabsComponent } from './components/nav-tabs/nav-tabs.component';
import { PlanCardComponent } from './components/plan-card/plan-card.component';
import { RawDataComponent } from './components/raw-data/raw-data.component';
import { SearchBarComponent } from './components/search-bar/search-bar.component';
import { SidenavMenuComponent } from './components/sidenav-menu/sidenav-menu.component';
import { SimpleCheckboxComponent } from './components/simple-checkbox/simple-checkbox.component';
import { SimpleDropdownComponent } from './components/simple-dropdown/simple-dropdown.component';
import { SingleSelectorComponent } from './components/single-selector/single-selector.component';
import { SliderComponent } from './components/slider/slider.component';
import { TimeSerieCardComponent } from './components/time-serie-card/time-serie-card.component';
import { TinyBotSpinnerComponent } from './components/tiny-bot-spinner/tiny-bot-spinner.component';
import { ToggleStatesComponent } from './components/toggle-states/toggle-states.component';
import { ToggleComponent } from './components/toggle/toggle.component';
import { UserAvatarComponent } from './components/user-avatar/user-avatar.component';
import { YoutubeDisplaySupportComponent } from './components/youtube-display-support/youtube-display-support.component';
// Directives
import { InputAutofocusDirective } from './directives/input-autofocus.directive';
import { InputDisabledFixDirective } from './directives/input-disabled-fix.directive';
import { InnerSidenavComponent } from './inner-sidenav/inner-sidenav.component';
import { ListButtonsSelectorComponent } from './list-buttons-selector/list-buttons-selector.component';

@NgModule({
  imports: [
    AccordionModule.forRoot(),
    BsDatepickerModule.forRoot(),
    AlertModule.forRoot(),
    BsDropdownModule,
    CommonModule,
    FormsModule,
    PerfectScrollbarModule,
    PipesModule,
    ProtocolDroidModule,
    ReactiveFormsModule,
    RouterModule,
    SvgIconModule,
    TooltipModule.forRoot()
  ],
  declarations: [
    AlertWarningComponent,
    ButtonCopyComponent,
    DatePickerComponent,
    ApiActionFormComponent,
    AvatarComponent,
    BadgeComponent,
    BadgeErrorsComponent,
    BadgeInfosComponent,
    BotChannelIconeComponent,
    BoxDashComponent,
    ButtonFlashingComponent,
    ButtonIconComponent,
    ButtonRoundComponent,
    CaretComponent,
    EmailActionFormComponent,
    EphemeralMessageComponent,
    FileUploadComponent,
    InnerSidenavComponent,
    InputAutofocusDirective,
    InputDisabledFixDirective,
    InputTextComponent,
    ListButtonsSelectorComponent,
    MultipleSelectionDropdownComponent,
    NavPanelsComponent,
    NavTabsComponent,
    PlanCardComponent,
    SearchBarComponent,
    SidenavMenuComponent,
    SimpleCheckboxComponent,
    SimpleDropdownComponent,
    SingleSelectorComponent,
    SliderComponent,
    TinyBotSpinnerComponent,
    ToggleComponent,
    ToggleStatesComponent,
    UserAvatarComponent,
    WorkflowActionFormComponent,
    YoutubeDisplaySupportComponent,
    TimeSerieCardComponent,
    RawDataComponent
  ],
  providers: [],
  exports: [
    AccordionModule,
    AlertWarningComponent,
    AlertModule,
    AvatarComponent,
    BadgeComponent,
    BadgeErrorsComponent,
    BadgeInfosComponent,
    BotChannelIconeComponent,
    BoxDashComponent,
    ButtonIconComponent,
    ButtonRoundComponent,
    BsDatepickerModule,
    ButtonCopyComponent,
    ButtonFlashingComponent,
    CaretComponent,
    DatePickerComponent,
    EphemeralMessageComponent,
    FileUploadComponent,
    InnerSidenavComponent,
    InputAutofocusDirective,
    InputDisabledFixDirective,
    InputTextComponent,
    ListButtonsSelectorComponent,
    MultipleSelectionDropdownComponent,
    NavPanelsComponent,
    NavTabsComponent,
    PlanCardComponent,
    RouterModule,
    SearchBarComponent,
    SidenavMenuComponent,
    SliderComponent,
    SimpleCheckboxComponent,
    SimpleDropdownComponent,
    SingleSelectorComponent,
    SvgIconModule,
    TinyBotSpinnerComponent,
    ToggleComponent,
    ToggleStatesComponent,
    TooltipModule,
    UserAvatarComponent,
    YoutubeDisplaySupportComponent,
    TimeSerieCardComponent,
    RawDataComponent
  ]
})
export class UiElementsModule {}
